import './back_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['show']

  connect = (): void => {
    if (this.notFirstPage) {
      this.show()
    } else {
      this.hide()
    }
  }

  navigate = (): void => {
    history.back()
  }

  show = (): void => {
    this.element.classList.add(this.showClass)
  }

  hide = (): void => {
    this.element.classList.remove(this.showClass)
  }

  get notFirstPage (): boolean {
    return history.length > 1
  }
}
